@if (statisticData[0].id) {
  <div id="chart-{{statisticData[0].id}}" class="chart-container-size"></div>
}
